<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e1498">
<p class="tx1"><br/><br/><br/>Between two groups of men that want to make inconsistent kinds of worlds I see no remedy except force … It seems to me that every society rests on the death of men.<br/><br/><br/></p>
<p class="tx1"><i>Oliver Wendell Holmes</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// helm.vue?12a5f6ec